import React, { useEffect, useRef } from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    CardActionArea,
    Typography,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Drawer,
    IconButton
} from "@mui/material";
import { useState, useContext } from "react";
import { ReactComponent as NoDataIcon } from "../../../images/NoDataCapturedIcon.svg";
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ReactComponent as UploadIcon } from "../../../images/uploadIcon.svg";
import { ReactComponent as ImportSwaggerIcon } from "../../../images/ImportSwaggerIcon.svg";
import { ReactComponent as ManualConfigIcon } from "../../../images/ManualConfigAPIIcon.svg";
import { Language } from "@mui/icons-material";
import { ReactComponent as WhiteUploadIcon } from "../../../images/WhiteUploadIcon.svg";
import yaml from "js-yaml";
import { ReactComponent as UploadFileIcon } from "../../../images/uploadedFileIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../images/APIDeleteNewIcon.svg";
import { ReactComponent as DocIcon } from "../../../images/MultisourceUploadDocIcon.svg"
import { ReactComponent as NewDeleteIcon } from "../../../images/OrangeAPIDeleteIcon.svg";
import { handleProgressBar } from "../../custom-components/ProgressBar/ProgressBarWithAPI.js";
import MessagePopup from "../../popup-components/MessagePopup";
import { htmlParsingForSwagger, endpoitnExtractionAPI, swaggerToPostman } from "../../../services/webServices";
import { LoadingModalContext } from "../../main-pages/ServicePage";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { useNavigate, useLocation } from "react-router-dom";
import ManualConfigForMultiSource from "./ManualConfigForMultiSource.js";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';



function MultiSourceCombination() {

    const [drawerOpen, setDrawerOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [fileContent, setFileContent] = useState(null);
    const [fileContentItems, setFileContentItems] = useState([]);
    const [popupOpen, setPopupOpen] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [fileContentEndpoints, setFileContentEndpoints] = useState([]);
    const [isIconNecessary, setIsIconNecessary] = useState(false);
    const [specUploadedContent, setSpecUploadedContent] = useState(false);
    const [displayPageContent, setDisplayPageContent] = useState([]);
    const [overAllEndpointExtractedData, setOverAllEndpointExtractedData] = useState([]);
    const [apiurl, setApiUrl] = useState("");
    const [authoType, setAuthoType] = useState("none");
    const [credentials, setCredentials] = useState("");
    const { setLoadingState } = useContext(LoadingModalContext);
    const [openAPISpec, setOpenAPISpec] = useState(null);
    const [swaggerEndpointExtractedData, setSwaggerEndpointExtractedData] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [editingIndex, setEditingIndex] = useState(null);
    const [discoveryMethod, setDiscoveryMethod] = useState("none");
    const [extractionMethod, setExtractionMethod] = useState("none");
    const [manualEndpoint, setManualEndpoint] = useState([]);
    const [manualURL, setManualURL] = useState("");
    const [manualProtocol, setManualProtocol] = useState("http://");
    const [manualConfigurationEndpoints, setManualConfigurationEndpoints] = useState([])




    const navigate = useNavigate();
    const location = useLocation();
    const processedEndpointsRef = useRef(new Set());

    useEffect(() => {
        console.log(location.state?.displayPageContent, "displayPageContent");
        console.log("display content", displayPageContent)

    }, [displayPageContent, overAllEndpointExtractedData]);



    useEffect(() => {
        setManualEndpoint(location.state?.endpoints || []);
        setManualURL(location.state?.apiUrl || "");
        setManualProtocol(location.state?.protocol || "http://");
        if (location.state?.endpoints && location.state?.endpoints.length > 0) {
            setDisplayPageContent(location.state?.displayPageContent || []);
            setOverAllEndpointExtractedData(location.state.overAllEndpointExtractedData || []);
            setIsIconNecessary(location.state?.isIconNecessary || false);
            setDisplayPageContent(location.state?.displayPageContent || []);
            setOverAllEndpointExtractedData(location.state?.overAllEndpointExtractedData || []);
            setUploadedFile(location.state?.uploadedFile || null);
            setDisplayPageContent((prev) => [
                ...prev,
                {
                    manualDetailsData: {

                        endpoints: location.state?.endpoints,
                        spec: location.state?.apiDocData
                    }
                }
            ]);

        }






    }, [location.state?.endpoints, location.state?.apiUrl, location.state?.protocol, location.state?.displayPageContent, location.state?.overAllEndpointExtractedData, location.state?.isIconNecessary, location.state?.uploadedFile, location.state?.apiDocData]);


    // useEffect(() => {
    //     if (location.state?.endpoints && location.state?.endpoints.length > 0) {
    //         const flattenedItems = flattenPostmanItems(location.state.endpoint);

    //         const batchSize = 3;
    //         const batches = [];
    //         const endpointsyaml = [];

    //         // Create batches
    //         for (let i = 0; i < flattenedItems.length; i += batchSize) {
    //             batches.push(flattenedItems.slice(i, i + batchSize));
    //         }

    //         const promises = batches.map(async (batch, batchIndex) => {
    //             try {
    //                 // Fixed typo: endpoitnExtractionAPI -> endpointExtractionAPI
    //                 const testcasesresponse = await endpoitnExtractionAPI({ item: batch });

    //                 if (testcasesresponse.data && testcasesresponse.data) {
    //                     console.log("yamlextracteddaata: ", testcasesresponse);
    //                     // Return the actual data instead of empty array
    //                     return testcasesresponse.data;
    //                 }

    //             } catch (error) {
    //                 console.log(
    //                     error?.response?.data?.error || error.message,
    //                     "Error processing batch:", batchIndex
    //                 );
    //             }
    //             return []; // Return empty array if no data or error
    //         });

    //         const results = await Promise.allSettled(promises);

    //         // Fixed: Access the fulfilled value correctly
    //         results.forEach((result) => {
    //             if (result.status === "fulfilled" && result.value) {
    //                 // If result.value is an array, spread it; if it's an object, push it
    //                 if (Array.isArray(result.value)) {
    //                     endpointsyaml.push(...result.value);
    //                 } else {
    //                     endpointsyaml.push(result.value);
    //                 }
    //             } else if (result.status === "rejected") {
    //                 console.error("One call failed:", result.reason);
    //             }
    //         });

    //         if (endpointsyaml && endpointsyaml.length > 0) {
    //             console.log("yaml endpoints data : ", endpointsyaml);
    //             setManualConfigurationEndpoints(endpointsyaml);
    //             setOverAllEndpointExtractedData((prev) => [
    //                 ...prev,
    //                 { manualEdnpointsData: endpointsyaml || [] }
    //             ]);
    //         }

    //     }

    // }, [location.state?.endpoints])

    useEffect(() => {
        const processEndpoints = async () => {

            if (!location.state?.endpoints || location.state.endpoints.length === 0) {
                return;
            }
            const endpointsHash = JSON.stringify(location.state.endpoints.map(ep => ep.id || ep.name || ep));



            // Skip if already processed
            if (processedEndpointsRef.current.has(endpointsHash)) {

                return;
            }

            // Mark as being processed
            processedEndpointsRef.current.add(endpointsHash);
            let progressHandler;
            progressHandler = handleProgressBar({ setLoadingState, totalDurationMs: 216000 });
            progressHandler.start("Extracting Endpoints");


            const flattenedItems = location.state.endpoints;

            const batchSize = 3;
            const batches = [];
            const endpointsyaml = [];

            // Create batches
            for (let i = 0; i < flattenedItems.length; i += batchSize) {
                batches.push(flattenedItems.slice(i, i + batchSize));
            }

            const promises = batches.map(async (batch, batchIndex) => {
                try {
                    const testcasesresponse = await endpoitnExtractionAPI({ item: batch });

                    if (testcasesresponse.data) {

                        return testcasesresponse.data;
                    }
                } catch (error) {
                    console.log(
                        error?.response?.data?.error || error.message,
                        "Error processing batch:", batchIndex
                    );
                    setPopupMessage("Error extracting enpoints.")
                }
                return [];
            });

            const results = await Promise.allSettled(promises);

            results.forEach((result) => {
                if (result.status === "fulfilled" && result.value) {
                    if (Array.isArray(result.value)) {
                        endpointsyaml.push(...result.value);
                    } else {
                        endpointsyaml.push(result.value);
                    }
                } else if (result.status === "rejected") {
                    console.error("One call failed:", result.reason);
                }
            });

            if (endpointsyaml.length > 0) {

                setManualConfigurationEndpoints(endpointsyaml);
                setOverAllEndpointExtractedData((prev) => [
                    ...prev,
                    { manualEndpointsData: endpointsyaml }
                ]);


            }
            await progressHandler.finishAndClose();

        };

        processEndpoints();
    }, [location.state?.endpoints]);


    const handleDrawerClose = () => {
        setSelectedOption(null);
        setDrawerOpen(false);
        setUploadedFile(null)
        if (!isEditing) {
            setApiUrl('');
            setAuthoType('none');
            setCredentials('');
        }

    }

    const extractEndpoints = (openApiSpec) => {
        if (!openApiSpec.paths) return [];

        const endpoints = [];

        Object.entries(openApiSpec.paths).forEach(([path, methods]) => {
            Object.entries(methods).forEach(([method, details]) => {
                endpoints.push({
                    method: method.toUpperCase(),
                    endpoint: path,
                    params: details.parameters
                        ? details.parameters.map((p) => p.name).join(", ")
                        : "-",
                    headers: details.responses?.["200"]?.content
                        ? Object.keys(details.responses["200"].content).join("/n")
                        : "-",
                    authType: details.security
                        ? details.security.flatMap(sec => Object.keys(sec)).join(", ")
                        : "-",
                    body: details.requestBody?.content
                        ? Object.keys(details.requestBody.content).join(", ")
                        : "-"



                });
            });
        });

        return endpoints;
    };

    const options = [
        {
            name: "upload",
            text: "Upload API Specs",
            subText: "Upload your API spec file to create test cases",
            icon: <UploadIcon />
        },
        {
            name: "swagger",
            text: "Import from Swagger URL",
            subText: "Import your Swagger UI URL to generate test cases",
            icon: <ImportSwaggerIcon />
        },
        {
            name: "website",
            text: "Analyse Live Website",
            subText: "Enter a URL to analyze its API endpoints",
            icon: <Language htmlColor="#0094FB" />
        },
        {
            name: "manual",
            text: "Manual Configuration",
            subText: "Enter End point details manually",
            icon: <ManualConfigIcon />
        }
    ];


    function flattenPostmanItems(items) {
        const flat = [];

        function recurse(subItems) {
            subItems.forEach(item => {
                if (item.request) {
                    flat.push(item); // it's a request
                } else if (item.item && item.item.length > 0) {
                    recurse(item.item); // it's a folder
                }
            });
        }
        recurse(items);
        return flat;
    }

    const handleFileUpload = async (event, droppedFile = null) => {
        const file = droppedFile || event.target.files[0];
        let progressHandler;

        if (!file) {
            setPopupMessage("No file selected or unsupported file type.");
            setPopupOpen(true);
            return;
        }

        const fileName = file.name;
        const validExtensions = [".json", ".yaml", ".yml", ".postman_collection"];
        const fileExtension = fileName
            .slice(fileName.lastIndexOf("."))
            .toLowerCase();

        if (!validExtensions.includes(fileExtension)) {
            setPopupMessage("Please upload a valid file (.json, .yaml, .yml).");
            setPopupOpen(true);
            return;
        }

        setUploadedFile(file);
        const reader = new FileReader();

        reader.onload = async (event) => {
            let forEndpoints = null;
            let yamlendpoints = null;
            try {
                const content = event.target.result;
                let parsedYAML;
                if (fileExtension === ".json" || fileExtension === ".postman_collection") {
                    parsedYAML = JSON.parse(content);

                } else {
                    parsedYAML = yaml.load(event.target.result);

                    yamlendpoints = parsedYAML
                }
                if (parsedYAML.item === undefined && fileExtension === ".json") {
                    // alert(
                    //   "Upload a valid input file.")
                    setPopupMessage("Upload a valid input file.");
                    setPopupOpen(true);
                    setUploadedFile(null)

                }
                if (parsedYAML && parsedYAML.item && parsedYAML.item.length > 0) {
                    forEndpoints = parsedYAML.item;
                    setFileContentItems(parsedYAML.item);



                }
                if (parsedYAML && Object.keys(parsedYAML).length > 0) {

                    setFileContent(parsedYAML);

                    // const endpoints = extractEndpoints(parsedYAML);
                    // setFileContentEndpoints(endpoints);


                }

                else {
                    setFileContent(null);
                }


                progressHandler = handleProgressBar({ setLoadingState, totalDurationMs: 216000 });
                progressHandler.start("Extracting Endpoints");
                if (forEndpoints && forEndpoints.length > 0) {
                    try {
                        //Mew code using promise for parallel calls
                        const promise = forEndpoints.map((item) => {
                            return endpoitnExtractionAPI(item)
                        })

                        const results = await Promise.allSettled(promise);
                        const allTestCases = [];
                        results.forEach((result) => {
                            if (result.status === "fulfilled" && result.value?.data) {
                                allTestCases.push(...result.value.data);
                            } else {
                                console.error("One call failed:", result.reason);
                            }
                        })

                        if (allTestCases && allTestCases.length > 0) {


                            setFileContentEndpoints(allTestCases)

                        }
                    } catch (error) {
                        console.error(error)
                    }
                }
                if (yamlendpoints !== null) {
                    const responseData = await swaggerToPostman(yamlendpoints);

                    if (responseData.data.item) {
                        const flattenedItems = flattenPostmanItems(responseData.data.item);

                        const batchSize = 3;
                        const batches = [];
                        const endpointsyaml = [];

                        // Create batches
                        for (let i = 0; i < flattenedItems.length; i += batchSize) {
                            batches.push(flattenedItems.slice(i, i + batchSize));
                        }

                        const promises = batches.map(async (batch, batchIndex) => {
                            try {
                                // Fixed typo: endpoitnExtractionAPI -> endpointExtractionAPI
                                const testcasesresponse = await endpoitnExtractionAPI({ item: batch });

                                if (testcasesresponse.data && testcasesresponse.data) {

                                    // Return the actual data instead of empty array
                                    return testcasesresponse.data;
                                }

                            } catch (error) {
                                console.log(
                                    error?.response?.data?.error || error.message,
                                    "Error processing batch:", batchIndex
                                );
                            }
                            return []; // Return empty array if no data or error
                        });

                        const results = await Promise.allSettled(promises);

                        // Fixed: Access the fulfilled value correctly
                        results.forEach((result) => {
                            if (result.status === "fulfilled" && result.value) {
                                // If result.value is an array, spread it; if it's an object, push it
                                if (Array.isArray(result.value)) {
                                    endpointsyaml.push(...result.value);
                                } else {
                                    endpointsyaml.push(result.value);
                                }
                            } else if (result.status === "rejected") {
                                console.error("One call failed:", result.reason);
                            }
                        });

                        if (endpointsyaml && endpointsyaml.length > 0) {

                            setFileContentEndpoints(endpointsyaml);
                        }
                    }
                }

                await progressHandler.finishAndClose();



            } catch (error) {
                console.error("Error parsing YAML:", error);
                setFileContent(null);
                setPopupMessage(
                    "Error parsing file. Please upload a valid YAML or JSON."
                );
                setPopupOpen(true);
                setUploadedFile(null)
            }
            finally {
                await progressHandler.finishAndClose();
            }
        };

        reader.readAsText(file);


    };

    const isOptionAlreadyAdded = (name) => {
        return displayPageContent.some((item) => {
            if (name === "manual" && item.manualDetailsData) return true;
            if (name === "swagger" && item.swaggerData) return true;
            if (name === "upload" && item.uploadedSpecification) return true;
            return false;
        });
    };


    const handleDeleteUploadedFile = (index) => {
        console.log("hi im hit")
        setDisplayPageContent(prev => prev.filter((_, i) => i !== index));
        setOverAllEndpointExtractedData(prev => prev.filter((_, i) => i !== index));
        // Add any other cleanup needed
    };



    const handleGenerateOpenAPISpec = async () => {
        const endpointsyaml = [];
        let progressHandler;
        try {
            progressHandler = handleProgressBar({ setLoadingState, totalDurationMs: 9000 });
            progressHandler.start("Generating API Document");
            const response = await htmlParsingForSwagger({ url: apiurl });


            if (response && response.data) {
                // setResponseParsedData(response.data);
                setOpenAPISpec(response.data.spec);
                // const endpoints = extractEndpoints(response.data.spec);
                // setSwaggerEndpointExtractedData(endpoints);

                if (response && response.data) {
                    //  setResponseParsedData(response.data);
                    setOpenAPISpec(response.data.spec);

                    // const endpoints = extractEndpoints(response.data.spec);
                    // setFileContentEndpoints(endpoints);

                }
                progressHandler.updateMessage("Extracting Endpoints")


                const responseData = await swaggerToPostman(response.data.spec);

                if (responseData.data.item) {

                    const flattenedItems = flattenPostmanItems(responseData.data.item);

                    const batchSize = 3;
                    const batches = [];


                    // Create batches
                    for (let i = 0; i < flattenedItems.length; i += batchSize) {
                        batches.push(flattenedItems.slice(i, i + batchSize));
                    }

                    const promises = batches.map(async (batch, batchIndex) => {
                        try {
                            // Fixed typo: endpoitnExtractionAPI -> endpointExtractionAPI
                            const testcasesresponse = await endpoitnExtractionAPI({ item: batch });

                            if (testcasesresponse.data && testcasesresponse.data) {

                                // Return the actual data instead of empty array
                                return testcasesresponse.data;
                            }

                        } catch (error) {
                            console.log(
                                error?.response?.data?.error || error.message,
                                "Error processing batch:", batchIndex
                            );
                        }
                        return []; // Return empty array if no data or error
                    });

                    const results = await Promise.allSettled(promises);

                    // Fixed: Access the fulfilled value correctly
                    results.forEach((result) => {
                        if (result.status === "fulfilled" && result.value) {
                            // If result.value is an array, spread it; if it's an object, push it
                            if (Array.isArray(result.value)) {
                                endpointsyaml.push(...result.value);
                            } else {
                                endpointsyaml.push(result.value);
                            }
                        } else if (result.status === "rejected") {
                            console.error("One call failed:", result.reason);
                        }
                    });

                    if (endpointsyaml && endpointsyaml.length > 0) {

                        setSwaggerEndpointExtractedData(endpointsyaml);
                    }

                }






                const newContent = {
                    // uploadedSpecification: true,
                    swaggerData: {
                        url: apiurl,
                        authType: authoType,
                        credentials: credentials,
                        spec: response.data.spec,
                        timestamp: Date.now()
                    }
                };

                const newEndpointData = {
                    swaggerData: endpointsyaml
                };

                if (isEditing && editingIndex !== null) {
                    // Update existing content
                    const updatedDisplayContent = [...displayPageContent];
                    updatedDisplayContent[editingIndex] = newContent;
                    setDisplayPageContent(updatedDisplayContent);

                    const updatedEndpointContent = [...overAllEndpointExtractedData];
                    updatedEndpointContent[editingIndex] = newEndpointData;
                    setOverAllEndpointExtractedData(updatedEndpointContent);
                } else {
                    // Add new content
                    setDisplayPageContent(prev => [...prev, newContent]);
                    setOverAllEndpointExtractedData(prev => [...prev, newEndpointData]);
                }
                await progressHandler.finishAndClose();
                handleDrawerClose();




            }



        } catch (error) {
            console.error("Error generating OpenAPI spec:", error);
            setLoadingState({ open: false, message: "", progress: null });
            setPopupMessage("Error generating OpenAPI spec. Please check the API URL and try again.");
            setPopupOpen(true);
        } finally {

            if (progressHandler) {
                progressHandler.stop();
            }
            setLoadingState({ open: false, message: "", progress: null });
        }
    }

    const handleEdit = (index) => {
        const contentToEdit = displayPageContent[index];
        if (contentToEdit.swaggerData) {
            // Pre-fill form with existing data
            setApiUrl(contentToEdit.swaggerData.url);
            setAuthoType(contentToEdit.swaggerData.authType);
            setCredentials(contentToEdit.swaggerData.credentials);
            setSelectedOption("swagger"); // Set the selected option
            setIsEditing(true);
            setEditingIndex(index);
            setDrawerOpen(true);
        }
    };

    const handleNavigateToGenerateEndpoints = () => {
        navigate("/dashboard/api-testing/endpoints-display",
            {
                state: {
                    ...location.state,
                    overAllEndpointExtractedData: overAllEndpointExtractedData,
                    displayPageContent: displayPageContent
                }
            }
        )
    }




    return (
        <Box
            sx={{
                p: 1,
                bgcolor: "#F6F3F2",
                display: "flex",
                flexDirection: "column",
                height: "100%",
                maxHeight: "100%",
                minHeight: 0,
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    height: { xs: "60vh", sm: "100vh", md: "100vh" },

                    overflowY: "scroll",
                    scrollbarWidth: "none",
                    "&::-webkit-scrollbar": {
                        display: "none",
                    },
                    // mx: "auto",

                }}
            >
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 2, p: 2 }}>
                    <Typography variant="Subtitle1" fontWeight="bold" fontSize={17} >
                        Multi-Source Combination
                    </Typography>
                    {displayPageContent.length > 0 && (
                        <Button variant="outlined"
                            startIcon={<AddIcon htmlColor="#0094FB" />}
                            onClick={() => setDrawerOpen(true)}
                            sx={{
                                borderRadius: "8px", color: "#0094FB", borderColor: " #0094FB",
                                borderWidth: "2px",   // makes border bold
                                fontWeight: "bold", textTransform: "none",
                                padding: "4px 16px",
                                // mb: 1,
                                mt: -2
                            }
                            }>
                            Add another Source
                        </Button>
                    )}
                </Box>

                {displayPageContent.length === 0 && (

                    <Card
                        variant="outlined"
                        sx={{
                            borderRadius: 2,
                            // p: 2,
                            m: 2,
                            flex: 1,
                            border: "none",
                            backgroundColor: "#fff",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            minHeight: "70vh"
                        }}
                    >
                        <Box sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            // maxheight: "100%"

                        }}>
                            <NoDataIcon />

                        </Box>
                        <Box>
                            <Button variant="contained"
                                startIcon={<AddIcon />}
                                onClick={() => setDrawerOpen(true)}
                                sx={{ bgcolor: "#0094FB", textTransform: "none", borderRadius: 2, padding: "4px 16px", fontSize: 16, mt: 2.5 }}>

                                Add Source
                            </Button>
                        </Box>

                    </Card>
                )}



                {displayPageContent && displayPageContent.map((content, index) => (
                    <>
                        <Box key={index} sx={{ p: 2, pt: 1, pb: 0 }}>
                            {content.uploadedSpecification && (
                                <Card
                                    variant="outlined"
                                    sx={{
                                        borderRadius: 2,
                                        p: 2,
                                        bgcolor: "#ffff",
                                        border: "none",
                                         mb: 1.5,
                                        //    maxWidth: "1075px",   // limit width
                                        //      mx: "auto"  
                                    }}>
                                    <Box>
                                        <Box sx={{ alignItems: "center", justifyContent: "space-between", textAlign: "center", display: "flex", gap: 2, }}>
                                            <Typography variant="subtitle1" fontWeight={500} mb={1} fontSize={17}>
                                                Uploaded File
                                            </Typography>
                                            <Button
                                                onClick={() => handleDeleteUploadedFile(index)}
                                                sx={{ textTransform: "none", color: "#FF3B30", fontSize: 14 }}
                                                startIcon={<NewDeleteIcon />}

                                            >
                                                Delete
                                            </Button>

                                        </Box>

                                        <Box sx={{ alignItems: "center", justifyContent: "center", textAlign: "center", display: "flex", gap: 2, }}>
                                            <Box sx={{ alignItems: "flex-start", justifyContent: "flex-start", textAlign: "left", display: "flex", gap: 2, flexGrow: 1 }}>
                                                <DocIcon />
                                                <Box sx={{ flexGrow: 1 }}>
                                                    <Typography variant="body1" fontWeight={500} fontSize={14}>{content.uploadedSpecification.filedata.name}</Typography>
                                                    <Typography variant="body2" color="text.secondary" fontSize={12}>
                                                        {(content.uploadedSpecification.filedata.size / 1024).toFixed(1)} KB | {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                                    </Typography>
                                                </Box>
                                            </Box>

                                        </Box>
                                    </Box>
                                </Card>
                            )}

                            {content.swaggerData && content.swaggerData.spec && (
                                <Card
                                    variant="outlined"
                                    sx={{
                                        borderRadius: 2,
                                        p: 2,
                                        flex: 1,
                                        border: "none",
                                        backgroundColor: "#fff",
                                         mb: 0.7,
                                        mt: -1
                                        // maxWidth: "1075px",   // limit width
                                        //      mx: "auto"  
                                    }}
                                >
                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 1 }}>
                                        <Typography variant="Subtitle1" fontWeight={600} fontSize={17}>Import Swagger URL</Typography>

                                        <Button
                                            onClick={() => handleDeleteUploadedFile(index)}
                                            sx={{ textTransform: "none", color: "#FF3B30", fontSize: 14 }}
                                            startIcon={<NewDeleteIcon />}

                                        >
                                            Delete
                                        </Button>
                                    </Box>

                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2, mt: 1.5 }}>

                                        Connect directly to your API's Swagger/OpenAPI endpoint for real-time specification analysis </Typography>

                                    <TextField
                                        label="API Specification URL"
                                        variant="outlined"
                                        fullWidth
                                        value={content.swaggerData.url}

                                        placeholder="https://api.example.com/swagger.json"
                                        sx={{ mb: 3 }}
                                    >

                                    </TextField>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3 }}>
                                        <FormControl fullWidth>
                                            <InputLabel >Authentication Type</InputLabel>
                                            <Select
                                                label="Authentication Type"
                                                placeholder="Select Auth Type"
                                                defaultValue="none"
                                                value={content.swaggerData.authType}
                                            //  onChange={(e) => setAuthoType(e.target.value)}
                                            >
                                                <MenuItem value="none">None</MenuItem>
                                                <MenuItem value="apiKey">API Key</MenuItem>
                                                <MenuItem value="oauth2">OAuth 2.0</MenuItem>
                                                <MenuItem value="basic">Basic Auth</MenuItem>

                                            </Select>
                                        </FormControl>


                                        <TextField
                                            label="Credentials"
                                            fullWidth
                                            placeholder="Enter credentials"
                                            disabled={authoType === "none"}
                                            value={content.swaggerData.credentials}
                                        // onChange={(e) => setCredentials(e.target.value)}
                                        >
                                        </TextField>
                                    </Box>
                                </Card>
                            )}
                        </Box>
             
                        {content?.manualDetailsData && (
                            <Box sx={{ position: "relative" }}>
                                <fieldset disabled style={{
                                    border: "none",
                                    margin: 0,
                                    padding: 0,
                                    
                                }}>
                                    <ManualConfigForMultiSource
                                        endpoints={content.manualDetailsData.endpoints}
                                        protocol={manualProtocol}
                                        apiUrl={manualURL}
                                        hideButton={true}
                                    />
                                </fieldset>
                                <Box sx={{
                                    position: "absolute",
                                    top: 25,              // Distance from top
                                    right: 25,            // Distance from right
                                  
                                    zIndex: 10
                                }}>
                                    <Button
                                        onClick={() => handleDeleteUploadedFile(index)}
                                        sx={{ textTransform: "none", color: "#FF3B30", fontSize: 14 }}
                                        startIcon={<NewDeleteIcon />}

                                    >
                                        Delete
                                    </Button>
                                </Box>
                            </Box>
                        )}
                    </>
                ))}
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1, }}>
                <Button variant="outlined"
                    onClick={() => navigate("/dashboard/api-testing/landingpage")}
                    sx={{
                        borderRadius: "8px", color: "#0094FB", borderColor: " #0094FB",
                        borderWidth: "2px",   // makes border bold
                        fontWeight: "bold", textTransform: "none",
                        padding: "4px 16px",
                        ml: 2

                    }
                    }
                >
                    <ArrowBackIcon style={{ marginRight: 6, fontSize: 18 }} />
                    Back
                </Button>
                <Button
                    variant="contained"
                    sx={{
                        borderRadius: "8px",
                        backgroundColor: "#0094FB",
                        textTransform: "none",
                        fontWeight: "bold",
                        padding: "4px 16px",
                        mr: 2
                    }}
                    disabled={displayPageContent.length === 0}
                    onClick={handleNavigateToGenerateEndpoints}
                >
                    Generate Endpoints
                    <ArrowForwardIcon style={{ marginLeft: 8, fontSize: 18 }} />
                </Button>
            </Box>

            <MessagePopup
                modalOpen={popupOpen}
                message={popupMessage}
                okayHandler={() => setPopupOpen(false)}
            />




            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={handleDrawerClose}
                PaperProps={{ sx: { width: "40%", p: 3 } }}
            >
                {!selectedOption && (
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        minHeight: "100vh"
                    }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <IconButton onClick={handleDrawerClose}><ArrowBackIcon /></IconButton>
                                <Typography variant="subtitle1" fontWeight={700} fontSize={18}>Add Source</Typography>
                            </Box>
                            <IconButton onClick={handleDrawerClose}><CloseIcon /></IconButton>
                        </Box>

                        {/* Main content area - takes up remaining space */}
                        <Box sx={{
                            p: 2,
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            flex: 1
                        }}>
                            {options.map((opt, i) => {
                                return (
                                    <Card
                                        key={i}
                                        variant="outlined"
                                        sx={{
                                            borderRadius: 2, boxShadow: "none",
                                            opacity: opt.name === "website" ? 0.5 : 1
                                        }}

                                    >
                                        <CardActionArea
                                            disabled={opt.name === "website"}
                                            onClick={() => {
                                                if (opt.name === "website") return;
                                                setSelectedOption(opt.name);
                                                setIsIconNecessary(true);
                                                if (opt.name === "manual") {
                                                    navigate("/dashboard/api-testing/manual-multisource", {
                                                        state: {
                                                            ...location.state,
                                                            displayPageContent: displayPageContent,
                                                            overAllEndpointExtractedData: overAllEndpointExtractedData,
                                                            isIconNecessary: isIconNecessary,
                                                            uploadedFile: uploadedFile || null,

                                                        }
                                                    });
                                                }
                                            }}
                                            sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}
                                        >
                                            <CardContent sx={{ p: 0 }}>
                                                <Box sx={{ display: "flex", justifyContent: 'center', alignItems: "center", gap: 1, mb: 1, }}>
                                                    {opt.icon}
                                                    <Typography variant="subtitle1" sx={{ textAlign: "center" }}>{opt.text}</Typography>
                                                </Box>
                                                <Typography variant="body2" color="text.secondary">
                                                    {opt.subText}
                                                </Typography>
                                            </CardContent>
                                        </CardActionArea>
                                    </Card>
                                );
                            })}
                        </Box>

                        {/* Button container - sticks to bottom */}
                        <Box sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            p: 2,
                            mt: "auto", // This pushes the button to the bottom
                            mb: 2
                        }}>
                            <Button
                                variant="outlined"
                                sx={{
                                    borderRadius: "8px",
                                    color: "#0094FB",
                                    borderColor: "#0094FB",
                                    borderWidth: "2px",
                                    fontWeight: "bold",
                                    textTransform: "none",
                                    padding: "4px 16px"
                                }}
                                onClick={handleDrawerClose}
                            >
                                Cancel
                            </Button>
                        </Box>
                    </Box>
                )}

                {selectedOption && selectedOption === "upload" && (
                    <Box sx={{ display: "flex", flexDirection: "column", height: "100%", minHeight: "100vh" }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <IconButton onClick={handleDrawerClose} ><ArrowBackIcon /></IconButton>
                                <Typography variant="subtitle1" fontWeight={700} fontSize={18}>Upload API Spec</Typography>
                            </Box>
                            <IconButton onClick={handleDrawerClose}><CloseIcon /></IconButton>
                        </Box>

                        {/* Content area - takes up available space */}
                        <Box sx={{ flex: 1, mt: 1 }}>
                            <Card
                                variant="outlined"
                                sx={{
                                    borderRadius: 2,
                                    p: 2,
                                    flex: 1,
                                    mb: 2,
                                    border: "none",
                                    backgroundColor: "#fff",
                                }}
                            >
                                {/* Upload Specifications Section */}
                                <Card
                                    variant="outlined"
                                    sx={{
                                        borderRadius: 2,
                                        border: "2px dashed #0094FB",
                                        backgroundColor: "#E1F5FF",
                                        textAlign: "center",
                                        mb: 1,
                                        p: 0.5,
                                        mt: 1,
                                        cursor: "pointer",
                                        transition: "all 0.3s ease",

                                        "&.drag-over": {
                                            backgroundColor: "#B8E0FF",
                                            borderColor: "#0066B3",
                                        },

                                    }}
                                    onDragOver={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        e.currentTarget.classList.add("drag-over");
                                    }}
                                    onDragLeave={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        e.currentTarget.classList.remove("drag-over");
                                    }}
                                    onDrop={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        e.currentTarget.classList.remove("drag-over");

                                        const files = e.dataTransfer.files;
                                        if (files && files.length > 0) {
                                            const file = files[0];
                                            // Validate file type
                                            const validExtensions = ['.json', '.yaml', '.yml'];
                                            const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();

                                            if (validExtensions.includes(fileExtension)) {
                                                // Create a synthetic event object to pass to your existing handler
                                                handleFileUpload({ target: { files: [] } }, file);

                                            } else {
                                                setPopupMessage('Please upload a valid file format: json, yaml, or yml');
                                                setPopupOpen(true);
                                            }
                                        }
                                    }}

                                >
                                    <CardContent>
                                        <Box sx={{ display: "flex", justifyContent: "center", mb: 1.5, gap: 1 }}>
                                            <UploadIcon />
                                            <Typography variant="subtitle1">
                                                Upload API Specs
                                            </Typography>
                                        </Box>
                                        <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                                            Drag and drop your API definition file here, or click to select
                                            <br />
                                            Format: json, yaml, postman_collection
                                        </Typography>

                                        <Button
                                            variant="contained"
                                            component="label"
                                            sx={{ mt: 2, borderRadius: "8px", backgroundColor: "#0094FB", color: "#fff", textTransform: "none", mb: 0, }}
                                            onChange={handleFileUpload}
                                        >
                                            <WhiteUploadIcon style={{ marginRight: 8 }} />
                                            Choose File
                                            <input hidden accept=".json,.yaml,.yml" type="file" multiple />
                                        </Button>
                                    </CardContent>
                                </Card>
                            </Card>

                            {uploadedFile && (

                                <Box>
                                    <Typography variant="subtitle1" fontWeight={500} mb={1} fontSize={17}>
                                        Uploaded File
                                    </Typography>

                                    <Box sx={{ alignItems: "center", justifyContent: "center", textAlign: "center", mt: 2, display: "flex", gap: 2, }}>
                                        <Box sx={{ alignItems: "flex-start", justifyContent: "flex-start", textAlign: "left", display: "flex", gap: 2, flexGrow: 1 }}>
                                            <DocIcon />
                                            <Box sx={{ flexGrow: 1 }}>
                                                <Typography variant="body1" fontWeight={500} fontSize={14}>{uploadedFile.name}</Typography>
                                                <Typography variant="body2" color="text.secondary" fontSize={12}>
                                                    {(uploadedFile.size / 1024).toFixed(1)} KB | {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Button
                                            onClick={() => {
                                                setUploadedFile(null)
                                                setFileContentEndpoints(null);
                                            }}
                                            sx={{ textTransform: "none", color: "#FF3B30" }}
                                        >
                                            <DeleteIcon style={{ marginRight: 4, }} />
                                        </Button>
                                    </Box>
                                </Box>

                            )}
                        </Box>

                        {/* Buttons - Fixed at bottom - MOVED OUTSIDE content area */}
                        <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            gap: 2,
                            p: 2,
                            mb: 2,

                        }}>
                            <Button variant="outlined"
                                onClick={handleDrawerClose}
                                sx={{
                                    borderRadius: "8px", color: "#0094FB", borderColor: " #0094FB",
                                    borderWidth: "2px",   // makes border bold
                                    fontWeight: "bold", textTransform: "none",
                                    padding: "4px 16px",
                                    mb: 1,

                                }
                                }
                            >
                                Cancel
                            </Button>


                            <Button variant="contained" sx={{
                                borderRadius: "8px",
                                backgroundColor: "#0094FB",
                                textTransform: "none",
                                fontWeight: "bold",
                                padding: "4px 16px",
                                mb: 1,
                            }}
                                disabled={!uploadedFile}
                                onClick={() => {
                                    setSpecUploadedContent(true);
                                    setDisplayPageContent((prev) => [
                                        ...prev,
                                        {
                                            uploadedSpecification: {
                                                data: fileContentItems && fileContentItems.length > 0
                                                    ? fileContentItems
                                                    : fileContent,

                                                filedata: uploadedFile,
                                            },
                                        },
                                    ]);


                                    setOverAllEndpointExtractedData(prev => [...prev, { specuploaded: fileContentEndpoints }]);
                                    handleDrawerClose();

                                }}
                            >
                                Add
                            </Button>

                        </Box>
                    </Box>
                )}
                {selectedOption && selectedOption === "swagger" && (
                    <>
                        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <IconButton onClick={handleDrawerClose} ><ArrowBackIcon /></IconButton>
                                <Typography variant="subtitle1" fontWeight={700} fontSize={18}>Import from swagger URL</Typography>
                            </Box>
                            <IconButton onClick={handleDrawerClose}><CloseIcon /></IconButton>
                        </Box>
                        <Card
                            variant="outlined"
                            sx={{
                                borderRadius: 2,
                                p: 2,
                                flex: 1,
                                mb: 3,
                                border: "none",
                                backgroundColor: "#fff",


                            }}
                        >
                            {/* Upload Specifications Section */}


                            <TextField
                                label="API Specification URL"
                                variant="outlined"
                                fullWidth
                                value={apiurl}
                                onChange={(e) => setApiUrl(e.target.value)}
                                placeholder="https://api.example.com/swagger.json"
                                sx={{ mb: 3 }}
                            >

                            </TextField>

                            <FormControl fullWidth>
                                <InputLabel >Authentication Type</InputLabel>
                                <Select
                                    label="Authentication Type"
                                    placeholder="Select Auth Type"
                                    defaultValue="none"
                                    value={authoType}
                                    onChange={(e) => setAuthoType(e.target.value)}
                                    sx={{ mb: 3 }}
                                >
                                    <MenuItem value="none">None</MenuItem>
                                    <MenuItem value="apiKey">API Key</MenuItem>
                                    <MenuItem value="oauth2">OAuth 2.0</MenuItem>
                                    <MenuItem value="basic">Basic Auth</MenuItem>

                                </Select>
                            </FormControl>


                            <TextField
                                label="Credentials"
                                fullWidth
                                placeholder="Enter credentials"
                                disabled={authoType === "none"}
                                value={credentials}
                                onChange={(e) => setCredentials(e.target.value)}
                            >

                            </TextField>
                        </Card>
                        <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            gap: 2,
                            p: 2,
                            mb: 1,
                        }}>
                            <Button variant="outlined"
                                sx={{
                                    borderRadius: "8px", color: "#0094FB", borderColor: " #0094FB",
                                    borderWidth: "2px",   // makes border bold
                                    fontWeight: "bold", textTransform: "none",
                                    padding: "4px 16px",
                                    mb: 1,

                                }
                                }
                                onClick={handleDrawerClose}
                            >
                                Cancel
                            </Button>

                            <Button variant="contained" sx={{
                                borderRadius: "8px",
                                backgroundColor: "#0094FB",
                                textTransform: "none",
                                fontWeight: "bold",
                                padding: "4px 16px",
                                minHeight: "unset",
                                mb: 1,
                            }}
                                disabled={!apiurl.trim()}
                                onClick={handleGenerateOpenAPISpec}
                            >
                                {isEditing ? "Update" : "Add"}
                            </Button>

                        </Box>
                    </>

                )}

                {selectedOption && selectedOption === "website" && (
                    <>
                        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <IconButton onClick={handleDrawerClose} ><ArrowBackIcon /></IconButton>
                                <Typography variant="subtitle1" fontWeight={700} fontSize={18}>Analyse Live Website</Typography>
                            </Box>
                            <IconButton onClick={handleDrawerClose}><CloseIcon /></IconButton>
                        </Box>
                        <Card
                            variant="outlined"
                            sx={{
                                borderRadius: 2,
                                p: 2,
                                flex: 1,
                                mb: 3,
                                border: "none",
                                backgroundColor: "#fff",


                            }}
                        >
                            {/* Upload Specifications Section */}


                            <TextField
                                label="API Specification URL"
                                variant="outlined"
                                fullWidth
                                value={apiurl}
                                onChange={(e) => setApiUrl(e.target.value)}
                                placeholder="https://api.example.com/swagger.json"
                                sx={{ mb: 3 }}
                            >

                            </TextField>

                            <FormControl fullWidth>
                                <InputLabel >Discovery Method</InputLabel>
                                <Select
                                    label="Discovery Method"
                                    placeholder="Select"
                                    defaultValue="none"
                                    value={discoveryMethod}
                                    onChange={(e) => setDiscoveryMethod(e.target.value)}
                                    sx={{ mb: 3 }}
                                >
                                    <MenuItem value="none">None</MenuItem>
                                    <MenuItem value="apiKey">API Key</MenuItem>
                                    <MenuItem value="oauth2">OAuth 2.0</MenuItem>
                                    <MenuItem value="basic">Basic Auth</MenuItem>

                                </Select>
                            </FormControl>

                            <FormControl fullWidth>
                                <InputLabel >Extraction Method</InputLabel>
                                <Select
                                    label="Extraction Method"
                                    placeholder="Select"
                                    defaultValue="none"
                                    value={extractionMethod}
                                    onChange={(e) => setExtractionMethod(e.target.value)}
                                    sx={{ mb: 3 }}
                                >
                                    <MenuItem value="none">None</MenuItem>
                                    <MenuItem value="apiKey">API Key</MenuItem>
                                    <MenuItem value="oauth2">OAuth 2.0</MenuItem>
                                    <MenuItem value="basic">Basic Auth</MenuItem>

                                </Select>
                            </FormControl>

                        </Card>
                        <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            gap: 2,
                            p: 2,
                            mb: 1,
                        }}>
                            <Button variant="outlined"
                                sx={{
                                    borderRadius: "8px", color: "#0094FB", borderColor: " #0094FB",
                                    borderWidth: "2px",   // makes border bold
                                    fontWeight: "bold", textTransform: "none",
                                    padding: "4px 16px",
                                    mb: 1,

                                }
                                }
                                onClick={handleDrawerClose}
                            >
                                Cancel
                            </Button>

                            <Button variant="contained" sx={{
                                borderRadius: "8px",
                                backgroundColor: "#0094FB",
                                textTransform: "none",
                                fontWeight: "bold",
                                padding: "4px 16px",
                                minHeight: "unset",
                                mb: 1,
                            }}
                                disabled={!apiurl.trim()}
                            // onClick={handleGenerateOpenAPISpec}
                            >
                                {isEditing ? "Update" : "OK"}
                            </Button>

                        </Box>
                    </>

                )}

            </Drawer>
        </Box>

    );
}
export default MultiSourceCombination;